import { Box, ButtonBase, useTheme } from "@mui/material";
import Subheading from "../../../../components/theme/text/Subheading";
import Text from "../../../../components/theme/text/Text";
import NumberInput from "../../../../components/theme/inputs/NumberInput";
import { DropdownBase } from "../../../../components/theme/dropdowns/Dropdown";
import { tokens } from "../../../../theme";
import { useTranslation } from "react-i18next";

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

const EcheckInvoiceCosts = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();

    return (
        <Box
            sx={{
                mt:2,
                opacity: !props.isBundling ? 1 : 0.35,
            }}
        >
            <Subheading>{t("extra_costs_to_invoice")}</Subheading>
            <Box
                sx={{
                    mt:1.5,
                    p:2,
                    background:theme.palette.mode === "dark" ? colors.grey[300]: colors.grey[200],
                    borderRadius:4,
                }}
            >
                {/* List of costs to invoice */}
                <Box
                    sx={{
                        display:"flex",
                        flexDirection:'column',
                        gap:1,
                        mb:2,
                    }}
                >
                    {(props.invoiceProducts && props.invoiceProducts.length > 0 ) &&
                        props.invoiceProducts.map((ip,index) => (
                            <Box
                                key={"ip"+ip.id}
                                sx={{
                                    borderRadius:5,
                                    height:40,
                                    display:"flex",
                                    pl:2,
                                    pr:1,
                                    alignItems:"center",
                                    background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0]
                                }}
                            >
                                <Text sx={{mr:1.5}}>{ip.name}</Text>
                                <NumberInput
                                    onlyPositive
                                    maxWidth={200}
                                    btnSize={24}
                                    height={32}
                                    value={ip.amount}
                                    inputSX={{
                                        ml:"auto"
                                    }}
                                    change={(value) => {
                                            props.setInvoiceProducts((e) => {
                                            const existingProduct = e.find(product => product.id === ip.id);
                                            if (existingProduct) {
                                                return e.map(product =>
                                                    product.id === ip.id ? { ...product,
                                                        amount: value
                                                    } : product
                                                );
                                            } 
                                        })
                                    }}
                                />
                                <ButtonBase
                                    onClick={(e) => {
                                        props.setInvoiceProducts((e) => {
                                            return e.filter((_, i) => i !== index);
                                        })
                                    }}
                                    sx={{
                                        ml:0.5,
                                        height:32,
                                        width:32,
                                        color:colors.red[400],
                                        borderRadius:4,
                                    }}
                                >
                                    <DeleteOutlineOutlinedIcon/>
                                </ButtonBase>
                            </Box>
                        ))
                    }
                </Box>
                
                <DropdownBase
                    key={props.invoiceProducts.length}
                    displayName={"name"}
                    options={props.invoiceProductsEcheck}
                    selected={-1}
                    valueKey={"id"}
                    disallowDeselection
                    searchOptions={{
                        allowSelectionOnEnter:true,
                        enabled: true,
                        placeholder: t("search"),
                    }}
                    onChange={(selected) => {
                        const selectedOption = props.invoiceProductsEcheck.find((dbIp) => dbIp.id === selected);
                        if(selectedOption){
                            props.updateCostProduct(selectedOption)
                        }
                    }}
                >
                    <ButtonBase
                        sx={{
                            width:1,
                            borderRadius:5,
                        }}
                    >
                        <Box
                            sx={{
                                borderRadius:5,
                                display:'flex',
                                alignItems:'center',
                                justifyContent:"center",
                                width:1,
                                height:40,
                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                border:`1px solid ${theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[300]}`,
                                fontFamily:"Roboto, sans-serif",
                                color: colors.txt["primary"],
                                fontWeight:500,
                            }}
                        >
                            {t("choose_to_invoice_new_costs")}

                        </Box>
                    </ButtonBase>
                </DropdownBase>

            </Box>
        </Box>
    )
} 

export default EcheckInvoiceCosts;


export const EcheckInvoiceCostsReadOnly = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();

    return (
        <Box
            sx={{
                mt:2,
            }}
        >
            <Subheading>{t("extra_costs_to_invoice")}</Subheading>
            <Box
                sx={{
                    mt:1.5,
                    p:2,
                    background:theme.palette.mode === "dark" ? colors.grey[300]: colors.grey[200],
                    borderRadius:6,
                }}
            >
                <Box
                    sx={{
                        display:"flex",
                        flexDirection:'column',
                        gap:1,
                    }}
                >
                    {(props.invoiceProducts && props.invoiceProducts.length > 0 ) &&
                        props.invoiceProducts.map((ip,index) => (
                            <Box
                                key={"ip"+index}
                                sx={{
                                    borderRadius:5,
                                    height:40,
                                    display:"flex",
                                    pl:2,
                                    pr:0.5,
                                    alignItems:"center",
                                    background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0]
                                }}
                            >
                                <Text sx={{mr:1.5}}>{ip.name}</Text>
                                <Box
                                    sx={{
                                        ml:'auto',
                                        height:32,
                                        borderRadius:4,
                                        display:"flex",
                                        alignItems:"center",
                                        justifyContent:"center",
                                        maxWidth:150,
                                        flex:1,
                                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]
                                    }}
                                
                                >
                                    <Text semibold>{ip.amount}</Text>
                                </Box>
                                
                            </Box>
                        ))
                    }
                </Box>
            </Box>
        </Box>
    )
} 